module.exports = __webpack_public_path__ + "img/19.fbecd7aa.png";